/* istanbul ignore file */
const positiveNumberRegEx = /^((?!^0+$|0+[.]0+$)0|[1-9]\d{0,5})(?:[.]\d{1,2})?$/;

export default {
  positionId: {
    type: 'number',
    required: true,
  },
  contractDuration: {
    type: 'string',
    required: true,
    regex: {
      value: /^(?:(\d+y\s*)|(?:\d+m\s*)|(?:\d+d\s*))*$/,
      message: 'Contract duration must be in the format: "1y 6m 15d" (years, months, days).',
    },
  },
  competencyLevel: {
    type: 'enum',
    required: true,
  },
  offerCompensations: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        baseAmountType: {
          type: 'enum',
          required: false,
        },
        currency: {
          type: 'enum',
          required: true,
        },
        grossAmount: {
          type: 'string',
          required: false,
          minValue: {
            value: '$grossProbationAmount',
          },
          regex: {
            value: positiveNumberRegEx,
            message: 'Must be a positive number (max 6 digits and 2 decimals)',
          },
        },
        grossProbationAmount: {
          type: 'string',
          maxValue: {
            value: '$grossAmount',
            message: "Probation period value can't be greater than base amount value",
          },
          regex: {
            value: positiveNumberRegEx,
            message: 'Must be a positive number (max 6 digits and 2 decimals)',
          },
        },
        calculatedGrossAmount: {
          type: 'string',
          regex: {
            value: positiveNumberRegEx,
            message: 'Must be a positive number (max 6 digits and 2 decimals)',
          },
        },
        officeId: {
          type: 'number',
          required: true,
        },
        contractType: {
          type: 'enum',
          required: true,
        },
      },
    },
  },
};
